import Swiper from 'swiper';

export default {
  init() {
    new Swiper ('.news_slider__container', {
      // Optional parameters
      direction: 'horizontal',
      slidesPerView: 3,
      speed: 600,
      navigation: {
        nextEl: '.news_slider__next',
        prevEl: '.news_slider__prev',
      },
      breakpoints: {
        320: {
          slidesPerView: 1
        },
        768: {
          slidesPerView: 3
        }
      }
    })
  }
}
